/**
 * @generated by @puffin-tooling/esm-build — DO NOT EDIT BY HAND.
 *
 * Source of truth: this package's CJS entry (`lib/index.js`).
 * Regenerate with `pnpm esm:build`; CI fails if this file is stale
 * (see the esmBuildFreshness cross-app contract).
 *
 * This RE-EXPORTS the CJS surface rather than duplicating it. Hand-editing
 * it reintroduces PLN-CALENDAR-RULE-001 D4: two copies of one module,
 * drifting silently.
 */

import cjs from '../siteLinks.js';

export default cjs;

export const {
  SITE_LINK_KIND,
  SITE_LINK_LIMIT,
  SOCIAL_PLATFORM,
  isSiteLinkHref,
  isSocialPlatform,
} = cjs;
